import { dropdownPositioner } from "../dropdown.shared.styles.js";
import { menuPopup } from "./menu.styles.js";
import { MenuPanelNavigator } from "./menu.panel-navigator.js";
import { c } from "react/compiler-runtime";
import { jsx } from "react/jsx-runtime";
import { clsx } from "clsx";
import { Menu } from "@base-ui/react/menu";
//#region src/components/menu/menu.content.tsx
/** Portaled, positioned Menu surface. */
var MenuContent = (t0) => {
	const $ = c(16);
	const { "aria-label": ariaLabel, anchor, children, className, defaultPanel, onPanelChange, align: t1, side: t2, sideOffset: t3 } = t0;
	const align = t1 === void 0 ? "start" : t1;
	const side = t2 === void 0 ? "bottom" : t2;
	const sideOffset = t3 === void 0 ? 4 : t3;
	let t4;
	if ($[0] !== className) {
		t4 = clsx(menuPopup, className);
		$[0] = className;
		$[1] = t4;
	} else t4 = $[1];
	let t5;
	if ($[2] !== children || $[3] !== defaultPanel || $[4] !== onPanelChange) {
		t5 = defaultPanel === void 0 ? children : /* @__PURE__ */ jsx(MenuPanelNavigator, {
			defaultPanel,
			onPanelChange,
			children
		});
		$[2] = children;
		$[3] = defaultPanel;
		$[4] = onPanelChange;
		$[5] = t5;
	} else t5 = $[5];
	let t6;
	if ($[6] !== ariaLabel || $[7] !== t4 || $[8] !== t5) {
		t6 = /* @__PURE__ */ jsx(Menu.Popup, {
			"aria-label": ariaLabel,
			className: t4,
			children: t5
		});
		$[6] = ariaLabel;
		$[7] = t4;
		$[8] = t5;
		$[9] = t6;
	} else t6 = $[9];
	let t7;
	if ($[10] !== align || $[11] !== anchor || $[12] !== side || $[13] !== sideOffset || $[14] !== t6) {
		t7 = /* @__PURE__ */ jsx(Menu.Portal, { children: /* @__PURE__ */ jsx(Menu.Positioner, {
			align,
			anchor,
			className: dropdownPositioner,
			side,
			sideOffset,
			children: t6
		}) });
		$[10] = align;
		$[11] = anchor;
		$[12] = side;
		$[13] = sideOffset;
		$[14] = t6;
		$[15] = t7;
	} else t7 = $[15];
	return t7;
};
//#endregion
export { MenuContent };
